import { render, staticRenderFns } from "./appsCollapse.vue?vue&type=template&id=6b816836&"
import script from "./appsCollapse.vue?vue&type=script&lang=js&"
export * from "./appsCollapse.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports